import{useState as o}from"react";const c=r=>{const[e,n]=o(0),t=r?[r.low,r.medium,r.high,r.original]:null;return{getPicture:i=>{t&&e<t.length?(i.target.src=t[e],n(e+1)):r&&(i.target.src=r.original)}}};export{c as usePictureSrcSet};
